<template>
  <div>
    <Modal
      class="editBlock"
      v-model="modal"
      title="修改密码"
      width="35"
      footer-hide
      :styles="{top: '20%'}"
    >
      <div class="bodyhigh">
        <div class="bodytwice">
          <div class="content">
            <Form ref="form" :model="form" :rules="ruleInline" :label-width="120">
              <FormItem prop="newPassword" label="新密码">
                <Input
                  type="password"
                  v-model="form.newPassword"
                  placeholder="Password"
                  autocomplete="new-password"
                ></Input>
              </FormItem>
              <FormItem prop="confirmPassword" label="确认新密码">
                <Input
                  type="password"
                  v-model="form.confirmPassword"
                  placeholder="Password"
                  autocomplete="new-password"
                ></Input>
              </FormItem>
            </Form>
          </div>
        </div>
      </div>
      <div class="modal-body-footer">
        <div class="btngp">
          <Button class="btn" @click="confirm">提交</Button>
          <Button class="btn" @click="modal=false">取消</Button>
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  name: "ModifyPassWordModal",
  props: {
    modifyPasswordStatus: {
      type: Boolean,
      default: false
    },
    id: {
      type: Number,
      required: true
    }
  },
  data () {
    const validatePassCheck = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.form.newPassword) {
        callback(new Error('密码不相同'));
      } else {
        callback()
      }
    };
    return {
      form: {
        newPassword: '',
        confirmPassword: ''
      },
      ruleInline: {
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
        ],
        confirmPassword: [
          { required: true, validator: validatePassCheck, trigger: 'blur' },
        ]
      },
      second: 5,
      timer: ''
    }
  },
  computed: {
    ...mapGetters(['username']),
    modal: {
      get () {
        return this.modifyPasswordStatus
      },
      set (val) {
        this.$refs['form'].resetFields();
        this.$emit("update:modifyPasswordStatus", val)
      }
    }
  },
  methods: {
    confirm () {
      this.$refs['form'].validate((valid) => {
        if (!valid) {
          this.$Message.error('请完成表格!')
          return;
        } else {
          this.$axios.manauppass({
            maid: this.username.maid,
            upmaid: this.id,
            uppswd: this.form.newPassword,
          })
            .then(res => {
              if (res.status != 1) return this.$Message.error(res.msg)
              this.$Message.success(res.msg);
              this.modal = false
            })
            .catch(err => console.error(err))
        }
      })
    },
  }
}
</script>
<style lang="less">
.editBlock {
  .btngp {
    .btn.ivu-btn {
      line-height: 0;
      border: none;
    }
    .ivu-btn:hover {
      color: none;
      border: none;
    }
  }
}
</style>